import React from 'react'

import './FrequencySelector.scss'
import LabeledIcon from 'components/LabeledIcon'
import { serviceTypes } from '@src/globals'
import { isOperations } from 'utils/auth/user'

function FrequencySelector ({ input }) {
  const { value, onChange } = input

  return (
    <div className='FrequencySelector'>
      <LabeledIcon
        selected={value === serviceTypes.WEEKLY.id}
        onClick={() => onChange(serviceTypes.WEEKLY.id)}
        iconType='text'
        iconContent='S'
        label='Semanal'
        />

      <LabeledIcon
        selected={value === serviceTypes.ONE_TIME.id}
        onClick={() => onChange(serviceTypes.ONE_TIME.id)}
        iconType='text'
        iconContent='U'
        label='Único'
        />

      {isOperations() &&
        <LabeledIcon
          selected={value === serviceTypes.MULTIPLE.id}
          onClick={() => onChange(serviceTypes.MULTIPLE.id)}
          iconType='text'
          iconContent='M'
          label='Múltiples veces a la semana'
          />
      }
    </div>
  )
}

export default FrequencySelector



// WEBPACK FOOTER //
// ./src/screens/App/screens/Booking/screens/ServiceSetup/screens/DateTimeForm/components/FrequencySelector/FrequencySelector.js